import { render } from "./GenericWidgetGrid.vue?vue&type=template&id=50b0299a&scoped=true"
import script from "./GenericWidgetGrid.vue?vue&type=script&lang=js"
export * from "./GenericWidgetGrid.vue?vue&type=script&lang=js"

import "./GenericWidgetGrid.vue?vue&type=style&index=0&id=50b0299a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b0299a"]])

export default __exports__